export default __webpack_public_path__ + "plane.png";